import { request } from '@/shared/api/request'
export const downloadFileByUid = (fileGuid) =>
	request({
		url: `contract/labor/laborTempFile/${fileGuid}`,
		method: 'GET',
		responseType: 'blob',
	})
